import styled from 'styled-components/macro';
import { TextInput as OrgTextInput } from 'visits-style';

const TextInput = styled(OrgTextInput)`
  height: 40px;
  font-size: 18px;
`;

export default TextInput;
